<script>
  import ItemResponse from "./ItemResponse.svelte";
  export let title;
  export let inputFocusAction;
  export let inputBlurAction;
  export let updateTitle;
  export let checkName;
  export let afterDelete;
</script>

<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-form-row">
    <div class="menu-second-level">
      <i class="bi bi-card-heading me-1" />Title {title.name || ""}
    </div>
  </div>
</div>

<div class="dupo-menu-pane">
  <div class="dupo-menu-pane-row">
    <h3 class="h-sub">Title text</h3>
  </div>
</div>
<!-- name -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="nameString"
    token="name"
    title="Name"
    {inputFocusAction}
    {inputBlurAction}
    validator={checkName}
    value={title.name}
    changeAction={(event) => {
      updateTitle(event, "title.name", title);
    }}
  />
</div>
<!-- text -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="longText"
    token="title"
    title="Text"
    {inputFocusAction}
    {inputBlurAction}
    value={title.text}
    changeAction={(event) => {
      updateTitle(event, "title.text", title);
    }}
  />
</div>
<!-- align -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="textAlign"
    token="align"
    title="Text align"
    {inputFocusAction}
    {inputBlurAction}
    value={title.align}
    changeAction={(event) => {
      updateTitle(event, "title.align", title);
    }}
  />
</div>
<!-- align -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="textAlign"
    token="align-layout"
    title="Box position"
    {inputFocusAction}
    {inputBlurAction}
    value={title.orient}
    changeAction={(event) => {
      updateTitle(event, "title.orient", title);
    }}
  />
</div>
<!-- font size -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="fontSize"
    token="fontSize"
    title="Font size"
    {inputFocusAction}
    {inputBlurAction}
    value={title.fontSize || 16}
    changeAction={(event) => {
      updateTitle(event, "title.fontSize", title);
    }}
  />
</div>
<!-- font weight -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="fontWeight"
    token="fontWeight"
    title="Font weight"
    {inputFocusAction}
    {inputBlurAction}
    value={title.fontWeight || "400"}
    changeAction={(event) => {
      updateTitle(event, "title.fontWeight", title);
    }}
  />
</div>
<!-- color -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="color"
    token="color"
    title="Font color"
    {inputFocusAction}
    {inputBlurAction}
    value={title.fontColor || "rgba(0,0,0,1)"}
    changeAction={(event) => {
      updateTitle(event, "title.color", title);
    }}
  />
</div>
<!-- line height -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="number"
    token="lineHeight"
    title="Line height"
    min="0"
    {inputFocusAction}
    {inputBlurAction}
    value={title.lineHeight}
    changeAction={(event) => {
      updateTitle(event, "title.lineHeight", title);
    }}
  />
</div>

<div class="dupo-menu-pane mt-3">
  <div class="dupo-menu-pane-row">
    <h3 class="h-sub">Title box</h3>
  </div>
</div>
<!-- width -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="width"
    token="width"
    title="Box width"
    {inputFocusAction}
    {inputBlurAction}
    value={title.width}
    changeAction={(event) => {
      updateTitle(event, "title.width", title);
    }}
  />
</div>
<!-- margin-bottom -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="size"
    token="offset"
    title="Offset (from bottom)"
    {inputFocusAction}
    {inputBlurAction}
    value={title.offset || 15}
    changeAction={(event) => {
      updateTitle(event, "title.offset", title);
    }}
  />
</div>
<!-- opacity -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="opacity"
    token="opacity"
    title="Title box opacity"
    {inputFocusAction}
    {inputBlurAction}
    value={title.opacity || 1}
    changeAction={(event) => {
      updateTitle(event, "title.opacity", title);
    }}
  />
</div>

<!-- lock -->
<div class="pane-divider" />
<div class="dupo-menu-pane pt-2">
  <ItemResponse
    type="lock"
    tooltipMessage="Prevent suggesting responsive alternatives that make changes to this title. Element-Lock applies to its source or target design(s)."
    title="Lock this title"
    token={"title-lock"}
    value={title.lock}
    {inputFocusAction}
    {inputBlurAction}
    changeAction={(event) => {
      updateTitle(event, "lock", title);
    }}
  />
</div>

<div class="pane-divider mt-5" />
<!-- removal -->
<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-button-row">
    <button
      type="button"
      on:click={(event) => {
        updateTitle("remove", "title", title);
        if (afterDelete) afterDelete(event);
      }}><i class="bi bi-eraser me-1" /> Delete this title</button
    >
  </div>
</div>
